var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-container",
        [
          _c(
            "v-card",
            {
              staticClass: "soli-round mb-5 stripe-shadow",
              attrs: { outlined: "" },
            },
            [
              _c(
                "v-card-subtitle",
                { staticClass: "pb-0 justify-start flex" },
                [_vm._v("Amount Due")]
              ),
              _vm._v(" "),
              _vm.amountDue
                ? _c("v-card-title", { staticClass: "pt-0" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.formatUnitAmount(_vm.amountDue)) +
                        "\n            "
                    ),
                  ])
                : _c("v-skeleton-loader", {
                    staticClass: "short-bone",
                    attrs: { "max-width": "200", type: "list-item" },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c("form", { attrs: { id: "payment-form" } }, [
            _c("div", { attrs: { id: "payment-element" } }),
            _vm._v(" "),
            _c("div", { attrs: { id: "error-message" } }),
          ]),
          _vm._v(" "),
          _c("v-card-text", { staticClass: "pb-0 mt-4" }, [
            _vm._v(
              "\n            This will schedule an assessment lesson with\n            "
            ),
            _c("a", [_vm._v(_vm._s(_vm.teacherName))]),
            _vm._v(" risk free with our\n            "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://musicologielessons.com/why-choose-musicologie",
                  target: "_blank",
                },
              },
              [_vm._v("Perfect Match Promise")]
            ),
            _vm._v(
              "\n            Your card will be charged\n            " +
                _vm._s(
                  _vm.amountDue ? _vm.formatUnitAmount(_vm.amountDue) : "..."
                ) +
                ". You'll\n            receive a welcome email at "
            ),
            _c("a", [_vm._v(_vm._s(_vm.email))]),
            _vm._v(" with further\n            instructions.\n        "),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.errors
        ? _c("p", { staticClass: "caption red--text mx-auto" }, [
            _vm._v(
              "\n        " + _vm._s(Object.values(_vm.errors)[0]) + "\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "pb-0" },
        [
          _vm.showSubmit
            ? _c("SoliBtn", {
                attrs: {
                  gradient: _vm.valid ? "gradient-orange" : null,
                  text: "Book It!",
                  icon: "music_note",
                  block: "",
                  disabled: !_vm.valid,
                  loading: _vm.loading,
                },
                on: {
                  click: function ($event) {
                    return _vm.submitManualCard()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }